import { MedicalInsure } from "@/core/constants/medicalInsure";

export const getInsuranceCompanyName = (code: MedicalInsure | string = "") => {
  const arr = code.split(" ");

  arr.splice(arr.length - 1, 1);

  return arr.join(" ");
};
